import { render, staticRenderFns } from "./MarketId.vue?vue&type=template&id=aa2864dc&scoped=true"
import script from "./MarketId.vue?vue&type=script&lang=js"
export * from "./MarketId.vue?vue&type=script&lang=js"
import style0 from "./MarketId.vue?vue&type=style&index=0&id=aa2864dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2864dc",
  null
  
)

export default component.exports